import React from "react";
import { Scale, Clock, ShieldCheck, Users, FileCheck, Wallet } from "lucide-react";

const benefits = [
  {
    icon: Scale,
    title: "Compara antes de decidir",
    desc: "Accede a varias ofertas de entidades financieras y elige la que tenga mejor CAE y cuota para tu situación.",
    span: "lg:col-span-2",
  },
  {
    icon: ShieldCheck,
    title: "Transparencia total",
    desc: "Toda la información de tasa, CAE, plazo y costo total te la entrega la entidad financiera de forma clara.",
    span: "lg:col-span-1",
  },
  {
    icon: Clock,
    title: "Proceso en línea",
    desc: "Solicita desde cualquier dispositivo, cuando quieras.",
    span: "lg:col-span-1",
  },
  {
    icon: Users,
    title: "Red de entidades aliadas",
    desc: "Trabajamos con distintas instituciones financieras para aumentar tus posibilidades de encontrar una opción adecuada.",
    span: "lg:col-span-2",
  },
  {
    icon: FileCheck,
    title: "Sin costo para ti",
    desc: "Comparar opciones con Bancoorp es completamente gratuito. Solo pagas el crédito que contrates con la entidad elegida.",
    span: "lg:col-span-2",
  },
  {
    icon: Wallet,
    title: "Tú tienes el control",
    desc: "Nunca te obligamos a aceptar una oferta. La decisión es 100% tuya.",
    span: "lg:col-span-1",
  },
];

export default function Benefits() {
  return (
    <section
      className="py-20 lg:py-28 bg-slate-50 border-y border-slate-200"
      data-testid="benefits-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-sm uppercase tracking-[0.2em] font-bold text-blue-600">
              Beneficios
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
              Un servicio pensado para decidir con información
            </h2>
          </div>
          <p className="max-w-md text-slate-600 leading-relaxed">
            No prometemos aprobaciones garantizadas ni “dinero inmediato”. Te
            entregamos las herramientas para comparar y elegir con criterio.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-5">
          {benefits.map((b, i) => (
            <div
              key={i}
              className={`${b.span} rounded-2xl bg-white border border-slate-200 p-7 transition-all duration-300 hover:-translate-y-1 hover:shadow-lg`}
              data-testid={`benefit-${i + 1}`}
            >
              <div className="h-10 w-10 rounded-lg bg-teal-100 text-teal-700 flex items-center justify-center mb-4">
                <b.icon className="h-5 w-5" strokeWidth={2} />
              </div>
              <h3 className="text-lg font-semibold text-slate-900">{b.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                {b.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
